import {predefinedButtonFilter, predefinedInvoiceTypes} from "./PredefinedInvoiceTypes";

export function hasDepoIade(newPreDefined,type) {
    // return true;
    return predefinedButtonFilter(predefinedInvoiceTypes.find(value => value.value === "DEPO_IADE"),newPreDefined,type);
}